CustomTC.define('modules/share/share',['modules/util', 'modules/core', 'modules/config', 'modules/constants', 'modules/options', 'modules/language', 'text!modules/share/htmls/share.html', 'css!modules/share/css/share'], function(util, core, config, constants, options,language, share) {
    return {
    	shareText: 'Watch this interactive TouchCast:',
        // init
        init: function(playerUI) {
            this.playerUI = playerUI;
            core.init('body').find('.' + constants.CSS_TOUCHCAST_PLAYER_TOOLS + '').append(share);
            if (util.isiPod() || util.isiPhone() || util.getIEVersion() === 8)
                core.hide(core.init('.' + constants.CSS_TOUCHCAST_SHARE_COPY_LINK + ''));

            var selectedSize = selectedWt = selectedHt = null;
            if (options.getTcVideoType() === 'note') {
                core.addClass(core.init('.' + constants.CSS_TOUCHCAST_NORMAL_EMBED_SIZES + ''), constants.CSS_TOUCHCAST_HIDE);
                core.removeClass(core.init('.' + constants.CSS_TOUCHCAST_SQUARE_EMBED_SIZES + ''), constants.CSS_TOUCHCAST_HIDE);
                selectedSize = core.init('.' + constants.CSS_TOUCHCAST_SQUARE_EMBED_SIZES + ' .' + constants.CSS_TOUCHCAST_SELECTED_EMBED_SIZE + '');
                selectedHt = core.getData(selectedSize, 'height') + 44;
            }
            else {
                core.addClass(core.init('.' + constants.CSS_TOUCHCAST_SQUARE_EMBED_SIZES + ''), constants.CSS_TOUCHCAST_HIDE);
                core.removeClass(core.init('.' + constants.CSS_TOUCHCAST_NORMAL_EMBED_SIZES + ''), constants.CSS_TOUCHCAST_HIDE);
                selectedSize = core.init('.' + constants.CSS_TOUCHCAST_NORMAL_EMBED_SIZES + ' .' + constants.CSS_TOUCHCAST_SELECTED_EMBED_SIZE + '');
                selectedHt = core.getData(selectedSize, 'height');
            }
            selectedWt = core.getData(selectedSize, 'width');
			this.setShareLink();
            this.setEmbedCode(selectedWt, selectedHt);
            this.initSharePanel();
            this.initTabs();
            this.initEmbedSizeSelection();
			this.setPlayerLanguageForShareModule(playerUI);
            this.setEmbedCodeWidth();
            this.setShareLinkWidth();
            this.resizeInput();
        },
        resizeInput: function() {
            var embedSizes = core.init('.' + constants.CSS_TOUCHCAST_EMBED_SIZES + '');
            var embedSizesWrapper = core.init('.' + constants.CSS_TOUCHCAST_EMBED_SIZES_WRAPPER + '');
            var embedLink = core.init('.' + constants.CSS_TOUCHCAST_EMBED_LINK + '');
            var wt = core.getInnerWidth(core.init('.' + constants.CSS_TOUCHCAST_SHARE_PANEL + '')) - 255;
            var copyLink = core.find(embedLink, '.' + constants.CSS_TOUCHCAST_SHARE_COPY_LINK + '');
            if (copyLink.length > 0) {
                this.setEmbedCodeWidth();
                this.setShareLinkWidth();
                //embedLink.width(core.getWidth(embedLink.parents('.' + constants.CSS_TOUCHCAST_SHARE_PANEL + '')) - core.getWidth(embedSizes) - parseInt(-core.getCss(copyLink, 'right').replace('px', '')));
                //embedLink.width(core.getWidth(embedLink.parents('.' + constants.CSS_TOUCHCAST_SHARE_PANEL + '')) - core.getWidth(embedSizesWrapper) - parseInt(-core.getCss(copyLink, 'right').replace('px', '')));
                /*core.setCss(core.init('.' + constants.CSS_TOUCHCAST_EMBED_LINK + ' input'), {
                    maxWidth: ((core.init('.' + constants.CSS_TOUCHCAST_EMBED_LINK + ':not(.' + constants.CSS_TOUCHCAST_COPY_TEXT_TO_ANIMATE + ') input').val().length + 1) * 11) + 'px'
                });*/
            }
            /*core.setCss(core.init('.' + constants.CSS_TOUCHCAST_SHARE_LINK + ''), {
                maxWidth: wt + 'px'
            });*/
        },
        initSharePanel: function() {
            var self = this;
            var shareBtn = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SHARE + '');
            var sharePanel = core.init('.' + constants.CSS_TOUCHCAST_SHARE_PANEL + '');
            core.removeClass(sharePanel, constants.CSS_TOUCHCAST_HIDE);
			
            core.off(shareBtn, 'touchstart click');
            core.on(shareBtn, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (core.hasClass(sharePanel, constants.CSS_TOUCHCAST_PANEL_SLIDE_DOWN)) {
                    self.showSharePopup(shareBtn, sharePanel);
                }
                else {
                    self.hideSharePopup(shareBtn, sharePanel);
                }
            });

            var shareCloseBtn = core.init('.' + constants.CSS_TOUCHCAST_SHARE_PANEL_CLOSE_BUTTON + '');
            core.off(shareCloseBtn, 'touchstart click');
            core.on(shareCloseBtn, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                self.hideSharePopup(shareBtn, sharePanel);
            });
        },
        initTabs: function() {
            var self = this;
            var sharePanel = core.init('.' + constants.CSS_TOUCHCAST_SHARE_PANEL + '');
            var shareTabMenus = core.init('#' + constants.CSS_TOUCHCAST_SHARE_TAB_MENUS + ' li > a');
            var shareTabSection = core.init('.' + constants.CSS_TOUCHCAST_SHARE_TAB_SECTION + '');
            core.off(shareTabMenus, 'touchstart click');
            core.on(shareTabMenus, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var tabSection = core.init(core.getAttr(core.init(this), 'href'));
                core.hide(shareTabSection);
                core.show(tabSection);
                core.removeClass(shareTabMenus, constants.CSS_TOUCHCAST_CURRENT);
                core.addClass(core.init(this), constants.CSS_TOUCHCAST_CURRENT);
                var obj = core.find(tabSection, '.' + constants.CSS_TOUCHCAST_SHARE_COPY_LINK + '');
                self.setEmbedCodeWidth();
                self.setShareLinkWidth();
                var txtToCopy = core.find(tabSection, '.' + constants.CSS_TOUCHCAST_SHARE_TEXT_TO_COPY + '');
                if (!util.isiPad() && !util.isiPod() && !util.isiPhone() && !util.isAndroid() && !util.isTouchDevice())
                    txtToCopy.select();
                return false;
            });
        },
        setEmbedCodeWidth: function() {
            var embedSizesWrapper = core.init('.' + constants.CSS_TOUCHCAST_EMBED_SIZES_WRAPPER + '');
            var embedLink = core.init('.' + constants.CSS_TOUCHCAST_EMBED_LINK + '');
            var copyLink = core.find(embedLink, '.' + constants.CSS_TOUCHCAST_SHARE_COPY_LINK + ':visible');
            var copyLinkOffset = 0;
            if (copyLink.length > 0)
                copyLinkOffset = parseInt(-core.getCss(copyLink, 'right').replace('px', ''));
            var embedLinkWt = core.getWidth(embedLink.parents('.' + constants.CSS_TOUCHCAST_SHARE_PANEL + '')) - core.getWidth(embedSizesWrapper) - copyLinkOffset - 13;
            core.setCss(embedLink, {
                width: embedLinkWt + 'px'
            });
        },
        setShareLinkWidth: function() {
             var shareIconsWrapper = core.init('.' + constants.CSS_TOUCHCAST_SHARE_ICONS_WRAPPER + '');
             var shareLink = core.init('.' + constants.CSS_TOUCHCAST_SHARE_LINK + '');
             var copyLink = core.find(shareLink, '.' + constants.CSS_TOUCHCAST_SHARE_COPY_LINK + ':visible');
             var copyLinkOffset = 0;
            if (copyLink.length > 0)
                copyLinkOffset = parseInt(-core.getCss(copyLink, 'right').replace('px', ''));
            var shareLinkWt = core.getWidth(shareLink.parents('.' + constants.CSS_TOUCHCAST_SHARE_PANEL + '')) - core.getWidth(shareIconsWrapper) - parseInt(core.getCss(shareIconsWrapper, 'margin-right').replace('px', '')) - copyLinkOffset - 13;
            core.setCss(shareLink, {
                width: shareLinkWt + 'px'
            });
        },
        initEmbedSizeSelection: function() {
            var self = this;
            var embedSizes = core.init('.' + constants.CSS_TOUCHCAST_EMBED_SIZES + '');
            core.off(embedSizes, 'touchstart click');
            core.on(embedSizes, 'touchstart click', function(e) {
                e.preventDefault();
                var embedValues = core.find(core.init(this).parent(), '.' + constants.CSS_TOUCHCAST_EMBED_VALUES);
                if (!core.hasClass(embedValues, constants.CSS_TOUCHCAST_OPEN)) {
                    core.removeClass(core.init('.' + constants.CSS_TOUCHCAST_EMBED_VALUES + ''), constants.CSS_TOUCHCAST_OPEN);
                    core.addClass(embedValues, constants.CSS_TOUCHCAST_OPEN);
                }
                else
                    core.removeClass(embedValues, constants.CSS_TOUCHCAST_OPEN);
                return false;
            });
            var embedSizeItems = core.init('.' + constants.CSS_TOUCHCAST_EMBED_SIZE_ITEM + '');
            core.off(embedSizeItems, 'touchstart click');
            core.on(embedSizeItems, 'touchstart click', function(e) {
                e.preventDefault();
                var item = core.init(this);
                var selectedWt = core.getData(item, 'width');
                var selectedHt = core.getData(item, 'height');
                if (options.getTcVideoType() === 'note')
                    selectedHt += 44;

                self.setEmbedCode(selectedWt, selectedHt);
                var embedSizeValues = item.parents('.' + constants.CSS_TOUCHCAST_EMBED_VALUES + '');
                core.find(embedSizeValues.parent(), '.' + constants.CSS_TOUCHCAST_SELECTED_EMBED_SIZE_LABEL).html(item.text());
                core.remove(core.find(embedSizeValues, '.' + constants.CSS_TOUCHCAST_EMBED_SIZE_TICK));
                core.removeClass(core.init('.' + constants.CSS_TOUCHCAST_EMBED_SIZE_ITEM + ''), constants.CSS_TOUCHCAST_SELECTED_EMBED_SIZE);
                core.append(item, '<i class="' + constants.CSS_TOUCHCAST_EMBED_SIZE_TICK + '"></i>');
                core.addClass(item, constants.CSS_TOUCHCAST_SELECTED_EMBED_SIZE);
                core.removeClass(embedSizeValues, constants.CSS_TOUCHCAST_OPEN);
                self.setEmbedCodeWidth();
                self.setShareLinkWidth();
                return false;
            });
        },
        updateInfo: function() {
            var embedSizeItem = core.init('.' + constants.CSS_TOUCHCAST_EMBED_SIZE_ITEM + '.' + constants.CSS_TOUCHCAST_SELECTED_EMBED_SIZE + '');
            var selectedWt = core.getData(embedSizeItem, 'width');
            var selectedHt = core.getData(embedSizeItem, 'height');
            if (options.getTcVideoType() === 'note')
                selectedHt += 44;

            this.setEmbedCode(selectedWt, selectedHt);
            this.setShareLink();
        },
        setShareLink: function() {
            var url = options.getVideoInfo()[options.getCurrentKey()].url;
            //core.init('.' + constants.CSS_TOUCHCAST_SHARE_LINK + ' div:first').html(url);
            core.setVal(core.init('.' + constants.CSS_TOUCHCAST_SHARE_LINK + ' input.' + constants.CSS_TOUCHCAST_SHARE_TEXT_TO_COPY), url);
            core.setAttr(core.init('.' + constants.CSS_TOUCHCAST_SHARE_FB_ICON + ''), 'href', 'https://www.facebook.com/sharer/sharer.php?u=' + url);
            core.setAttr(core.init('.' + constants.CSS_TOUCHCAST_SHARE_TWITTER_ICON + ''), 'href', 'https://twitter.com/share?url=' + url + '&via=TouchCast&text=' + this.getShareText());
        },
        setEmbedCode: function(w, h) {
            var width = w;
            var height = h;
            var embedCode = "<iframe width='"+ width + "' height='" + height + "' src='//" + options.getDomain() + "/embed/" + options.getVideoInfo()[options.getCurrentKey()].id + "' frameborder='0' allowfullscreen> </iframe>";
            core.setVal(core.init('.' + constants.CSS_TOUCHCAST_EMBED_LINK + ' input.' + constants.CSS_TOUCHCAST_SHARE_TEXT_TO_COPY), embedCode);
        },
        // get share text
        getShareText: function() {
        	return this.shareText;
        },
        showSharePopup: function(shareBtn, sharePanel) {
            var self = this;
            this.playerUI.clearControlSelections();
            core.addClass(shareBtn, constants.CSS_TOUCHCAST_SELECTED);
            core.removeClass(sharePanel, constants.CSS_TOUCHCAST_PANEL_SLIDE_DOWN);
            core.tooltipster(shareBtn, 'disable');
            var obj = core.init(core.find(sharePanel, '.' + constants.CSS_TOUCHCAST_SHARE_COPY_LINK + '')[0]);
            var txtToCopy = core.find(sharePanel, '.' + constants.CSS_TOUCHCAST_SHARE_TEXT_TO_COPY + ':visible');
            if (!util.isiPad() && !util.isiPod() && !util.isiPhone() && !util.isAndroid() && !util.isTouchDevice()) {
                setTimeout(function() {
                    txtToCopy.select();
                }, 100);
            }

            var clipboardOption = { 
                copy: function(e) {
                    var tabSection = core.init(e).parents('.' + constants.CSS_TOUCHCAST_SHARE_TAB_SECTION + '');
                    var txtToCopy = core.find(tabSection, '.' + constants.CSS_TOUCHCAST_SHARE_TEXT_TO_COPY + '');
                    return txtToCopy[0];
                },
                afterCopy: function(e) {
                    var tabSection = core.init(e.trigger).parents('.' + constants.CSS_TOUCHCAST_SHARE_TAB_SECTION + '');
                    var txtToCopy = core.find(tabSection, '.' + constants.CSS_TOUCHCAST_SHARE_TEXT_TO_COPY + '');
                    var txtToAnimate = core.find(tabSection, '.' + constants.CSS_TOUCHCAST_COPY_TEXT_TO_ANIMATE + '');
                    var eleType = txtToCopy[0].nodeName.toLowerCase();
                    var txt = '';
                    if (eleType === 'input' || eleType === 'textarea') {
                        txt = txtToCopy.val();
                        if (txtToAnimate[0].nodeName.toLowerCase() === 'input')
                            core.setVal(txtToAnimate, txt);
                        else
                            core.setVal(core.find(txtToAnimate, 'input'), txt);
                    }
                    else if (eleType === 'div') {
                        txt = txtToCopy.text();
                        txtToAnimate.html(txt);
                    }
                    core.addClass(txtToAnimate, constants.CSS_TOUCHCAST_ANIMATE);

                    setTimeout(function() {
                        if (eleType === 'input' || eleType === 'textarea') {
                            if (txtToAnimate[0].nodeName.toLowerCase() === 'input')
                                core.setVal(txtToAnimate, '');
                            else
                                core.setVal(core.find(txtToAnimate, 'input'), '');
                        }
                        else
                            txtToAnimate.html('');
                        core.removeClass(txtToAnimate, constants.CSS_TOUCHCAST_ANIMATE);
                    }, 500);
                },
                onError: function(e) {
                    var actionMsg;
                    if(/iPhone|iPad/i.test(navigator.userAgent)) {
                        actionMsg = 'No support :(';
                    }
                    else if (/Mac/i.test(navigator.userAgent)) {
                        actionMsg = 'Press ⌘-' + 'C to ' + e.action;
                    }
                    else {
                        actionMsg = 'Press Ctrl-' + 'C to ' + e.action;
                    }
                    var copyLink = core.init(e.trigger);
                    try {
                        core.tooltipster(copyLink, {
                            placement: 'top',
                            trigger: 'custom',
                            content: actionMsg
                        });
                        setTimeout(function() {
                            core.tooltipster(copyLink, 'show');
                        }, 100);
                        core.off(copyLink, 'mouseout');
                        core.on(copyLink, 'mouseout', function() {
                            core.tooltipster(core.init(this), 'hide');
                        });

                    } catch (err) {
                        console.error(err);
                    }
                }
            };
            core.copyClipboard('.' + constants.CSS_TOUCHCAST_SHARE_COPY_LINK + '', clipboardOption);

            setTimeout(function() {
                self.playerUI._resize();
            }, 400);
        },
        hideSharePopup: function(shareBtn, sharePanel) {
            core.removeClass(shareBtn, constants.CSS_TOUCHCAST_SELECTED);
            core.addClass(sharePanel, constants.CSS_TOUCHCAST_PANEL_SLIDE_DOWN);
            core.tooltipster(shareBtn, 'enable');
            core.destroyClipboard();
        },
		setPlayerLanguageForShareModule: function(playerUI){
			 var tcLangShare        		= core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_TOOLTIP + '');
			 var tcLangShareTab     		= core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_TAB_TEXT + '');
			 var tcLangEmbedTab				= core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_EMBED_TAB_TEXT + '');
			 var tcLangEmbedTab				= core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_EMBED_TAB_TEXT + '');
			 var shareLinkCopyLink			= core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_TAB_COPY_TEXT + '');
			 var tcShareEmbedLinkCopyLink	= core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_EMBED_TAB_COPY_TEXT + '');
			 var tcLangShareIconsFB			= core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_PANEL_FB_TOOLTIP + '');
			 var tcLangShareIconsTwitter	= core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_PANEL_TWITTER_TOOLTIP + '');
			 
			 playerUI._updateTooltipster(tcLangShare,language.getShareTooltip());
			 core.html(tcLangShareTab, language.getShareBoxShareTabText());
			 core.html(tcLangEmbedTab, language.getShareBoxEmbedTabText());
			 core.html(shareLinkCopyLink, language.getShareBoxEmbedCopyText());
			 core.html(tcShareEmbedLinkCopyLink, language.getShareBoxEmbedCopyText());
			 playerUI._updateTooltipster(tcLangShareIconsFB,language.getShareBoxShareIconFacebook());
			 playerUI._updateTooltipster(tcLangShareIconsTwitter,language.getShareBoxShareIconTwitter());
		}
    }
});
